import { useState, Fragment, useRef } from "react";

import { useHistory, useLocation, withRouter } from "react-router-dom";
import moment from "moment";
import useMifosProduct from "../../../custom-hooks/useMifosProduct";
import { putDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import Loader from "../../../NewComponents/Loader/Loader.component";
import Alert from "../../../NewComponents/Alert/Alert.component";
import { errorHandler } from "../../../helpers/errorHandler";
import CreateInvestmentModal from "./CreateInvestmentModal/CreateInvestmentModal";
import { ROLE_TYPES } from "./../../../helpers/roleTypes";
// Redux
import { connect } from "react-redux";
import { appInsights } from "../../../config/appInsights";
import CustomSearchDropDown from "../../CustomHTMLElements/CustomSearchDropDown/CustomSearchableDropdown";
import { getInvestmentCurrencies } from "../../../custom-hooks/useInvestmentCurrencies";
import { getCurrencyInfo } from "../helper";
import EditFinancials from "./CreateInvestmentsViews/EditFinancials";
import BackButtonComponent from "../../../NewComponents/BackButton/BackButton.component";

import styles from "./InvestmentProduct.module.scss";

const EditInvestmentProduct = (props) => {
  const [modalActionType, setModalActionType] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [saveDraftError, setSaveDraftError] = useState(null);
  const location = useLocation();
  const { data: dataToEdit, editType } = location?.state;

  const [state, setState] = useState({
    name: dataToEdit?.name || "",
    objective: dataToEdit?.objective || "",
    issuers: dataToEdit?.issuers || "",
    description: dataToEdit?.description || "",
    target_investors: dataToEdit?.target_investors || "",
    investment_type: dataToEdit?.investment_type || 1,
    start_date: dataToEdit?.start_date.substring(0, 10) || "",
    end_date: dataToEdit?.end_date.substring(0, 10) || "",
    investment_product_details: dataToEdit?.investment_product_details,
    //
    lcy_corebanking_id: dataToEdit?.lcy_corebanking_id || "",
    lcy_currency_code: dataToEdit?.lcy_currency_code || "",
    lcy_minimum_investment: dataToEdit?.lcy_minimum_investment || "",
    lcy_maximum_investment: dataToEdit?.lcy_maximum_investment || "",
    lcy_investment_size: dataToEdit?.lcy_investment_size || "",
    usd_corebanking_id: dataToEdit?.usd_corebanking_id || "",
    usd_currency_code: dataToEdit?.usd_currency_code || "",
    usd_minimum_investment: dataToEdit?.usd_minimum_investment || "",
    usd_maximum_investment: dataToEdit?.usd_maximum_investment || "",
    usd_investment_size: dataToEdit?.usd_investment_size || "",
    lcy_locked: dataToEdit?.lcy_locked || false,
    usd_locked: dataToEdit?.usd_locked || false,
  });
  const dismissModalRef = useRef();
  const history = useHistory();

  const handleSubmitDraft = async () => {
    setSaveDraftError(false);
    setLoading(true);
    const { start_date, end_date } = state;

    const reqBody = { ...state };

    reqBody.start_date = moment(start_date).format("DD/MM/YYYY");
    reqBody.end_date = moment(end_date).format("DD/MM/YYYY");

    if (editType === "drafted") {
      try {
        const response = await putDataWithDotNet(
          `${ajaxEndpoints.FUNDER_INVESTMENT_PRODUCT}/${dataToEdit.id}/update_pending`,
          reqBody
        );
        setLoading(false);
        setSuccessMessage(response.message);
        setTimeout(() => {
          history.push("/investments");
        }, 3000);
      } catch (error) {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "EditInvestmentProduct.jsx",
          },
        });
        setLoading(false);
        setSaveDraftError(errorHandler(error));
      }
    } else if (editType === "active") {
      let activeReqBody;

      const newInvestmentProductDetails = state.investment_product_details.map(
        (item) => {
          return {
            ...item,
            is_locked: JSON.parse(item?.is_locked),
          };
        }
      );

      activeReqBody = {
        end_date: moment(end_date).format("DD/MM/YYYY"),
        investment_product_details: newInvestmentProductDetails,
      };

      try {
        const response = await putDataWithDotNet(
          `${ajaxEndpoints.FUNDER_INVESTMENT_PRODUCT}/${dataToEdit.id}/update_active`,
          activeReqBody
        );
        setLoading(false);
        setSuccessMessage(response.message);
        setTimeout(() => {
          history.push("/investments");
        }, 3000);
      } catch (error) {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "EditInvestmentProduct.jsx",
          },
        });
        setLoading(false);
        setSaveDraftError(errorHandler(error));
      }
    }
  };

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    if (id) {
      const currentState = { ...state };

      const result = currentState.investment_product_details.find(
        (item) => item?.id === id
      );
      const indexOfResult = currentState.investment_product_details.findIndex(
        (item) => item === result
      );

      const newProductDetailsArray = currentState?.investment_product_details;
      newProductDetailsArray[indexOfResult] = {
        ...newProductDetailsArray[indexOfResult],
        [e.target.name]: e.target.value,
      };

      setState((prev) => ({
        ...prev,
        investment_product_details: newProductDetailsArray,
      }));
    } else {
      setState({ ...state, [name]: value });
    }
  };

  const getOptions = () => {
    return new Promise((resolve, reject) => {
      getInvestmentCurrencies()
        .then((data) => {
          resolve(
            data?.data.map((detail) => ({
              value: detail?.currency_code,
              label: detail?.currency_name,
            }))
          );
        })
        .catch(reject);
    });
  };

  const handleDropdownChange = (data) => {
    return setState((prev) => ({
      ...prev,
      investment_product_details: [...data],
    }));
  };

  const getInvestmentFundCurrency = (listInQuestion) => {
    if (listInQuestion && listInQuestion.length > 0) {
      const result = listInQuestion.map((item) => {
        return {
          label: getCurrencyInfo(item?.currency_code).name,
          value: item?.currency_code,
        };
      });

      return result;
    }

    return [];
  };

  const discardChanges = (e) => {
    e.preventDefault();
    if (dismissModalRef && dismissModalRef.current) {
      dismissModalRef.current.click();
    }
    setState({
      name: "",
      investment_type: 1,
      start_date: "",
      end_date: "",
      lcy_corebanking_id: "",
      lcy_currency_code: "",
      lcy_minimum_investment: "",
      lcy_maximum_investment: "",
      lcy_investment_size: "",
      usd_corebanking_id: "",
      usd_currency_code: "",
      usd_minimum_investment: "",
      usd_maximum_investment: "",
      usd_investment_size: "",
      lcy_locked: false,
      usd_locked: false,
    });
  };

  const {
    data: mifosData,
    status: mifosStatus,
    error: mifosError,
  } = useMifosProduct(3);

  if (mifosStatus === "loading") {
    return <Loader centered="true" text="Loading mifos information..." />;
  }
  if (mifosError) {
    return (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt p-y-5">
            <i className="fas fa-bell" /> There was an issue while loading the
            mifos products, please try again.
          </h4>
        </div>
      </div>
    );
  }
  return (
    <Fragment>
      <div
        className={`animated fadeInRight mt-2 ${styles.createInvestmentProduct}`}
      >
        <h3 className="page-title d-flex align-items-center">
          <BackButtonComponent /> Back
        </h3>

        <div className="d-flex flex-row flex-wrap mt-3 mb-1">
          {saveDraftError && <Alert message={saveDraftError} />}
          {successMessage && <Alert message={successMessage} type="success" />}
          <h3 className="page-title">Edit Product</h3>

          <div className="d-flex flex-row flex-wrap justify-content-end">
            {props.loggedInUser.roleTypes.includes(
              ROLE_TYPES.INVESTMENT_PRODUCT_SETUP
            ) ? (
              <div>
                <button
                  type="submit"
                  className="btn advancly-white-btn btn-md m-0"
                  onClick={handleSubmitDraft}
                  disabled={loading}
                >
                  Update
                  {loading && <Loader />}
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <h3 className="page-subtitle mb-3 ml-3">Investment Details</h3>
        <form>
          <div className="row col-8">
            <div className="col-md-12 mt-1">
              <label className="label-txt">Name of Fund</label>
              <input
                className="form-control"
                value={state.name}
                name="name"
                onChange={(e) => handleChange(e)}
                disabled={editType === "active"}
              />
            </div>

            <div className={styles.productBasicDetails}>
              <div className="col-md-6 pl-2">
                <label>Start date: </label>
                <input
                  type="date"
                  name="start_date"
                  className="form-control"
                  value={state.start_date}
                  disabled={editType === "active"}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="col-md-6">
                <div>
                  <label>End date: </label>
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    value={state.end_date}
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </div>
              <div className="col-md-6 mt-3 pl-2">
                <label className="label-txt">Description</label>
                <input
                  className="form-control"
                  value={state.description}
                  name="description"
                  disabled={editType === "active"}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label className="label-txt">Objective</label>
                <input
                  className="form-control"
                  value={state.objective}
                  name="objective"
                  disabled={editType === "active"}
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="col-md-6 mt-3 pl-2">
                <label className="label-txt">Issuer</label>
                <input
                  className="form-control"
                  value={state.issuers}
                  disabled={editType === "active"}
                  name="issuers"
                  onChange={(e) => handleChange(e)}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label className="label-txt">Target Investor</label>
                <input
                  className="form-control"
                  value={state.target_investors}
                  disabled={editType === "active"}
                  name="target_investors"
                  onChange={(e) => handleChange(e)}
                />
              </div>
            </div>

            <hr className={styles.divider}></hr>

            <div className="col-md-12 my-3">
              <label className="label-txt">
                What currencies are you accepting for this fund:
              </label>

              <div className="col-md-12 p-0">
                <CustomSearchDropDown
                  label="Select Currency"
                  onChange={handleDropdownChange}
                  loadOptions={getOptions}
                  disabled={true}
                  defaultValue={getInvestmentFundCurrency(
                    state?.investment_product_details
                  )}
                  defaultOptions={true}
                  name="user"
                  isShowLabel={false}
                  isMulti={true}
                  isSearchable={false}
                />
              </div>
            </div>

            <div className={styles.financialsContainer}>
              <div className="col-md-12">
                <h3 className="page-subtitle mb-2">Currencies:</h3>
              </div>

              {state?.investment_product_details.length < 1 && (
                <div className={styles.noCurrencyErrorContainer}>
                  You have not selected any currencies
                </div>
              )}

              {state?.investment_product_details.map((item, index) => (
                <EditFinancials
                  key={index}
                  mifosData={mifosData}
                  handleChange={handleChange}
                  state={state}
                  setState={setState}
                  editType={editType}
                  selectedProductDetails={item}
                />
              ))}
            </div>
          </div>
        </form>
      </div>
      <CreateInvestmentModal
        onSubmit={handleSubmitDraft}
        discardChanges={discardChanges}
        modalActionType={modalActionType}
        dismissModalRef={dismissModalRef}
        loading={loading}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  const { loggedInUser } = state.authReducer;

  return {
    loggedInUser,
  };
};

export default withRouter(connect(mapStateToProps)(EditInvestmentProduct));
